import { AppIdentifiers } from '../store/slices/token-state.slice';
import { getAppStore } from '../store/storeRef';
import fetchWrapper from '../utils/fetchWrapper';

interface FetchParams {
  url: string;
  method?: string;
  body?: any;
  cursor?: number;
  limit?: number;
  token?: AppIdentifiers;
  noCache?: boolean;
}

export default class RequestService {
  static async fetch({
    url,
    method = 'GET',
    body,
    cursor,
    limit,
    token = AppIdentifiers.App,
    noCache = false,
  }: FetchParams) {
    // Access the token for the specified type
    const appToken = getAppStore().getState().tokenState[token] ?? '';

    // if (!isTokenValid(appToken)) {
    //   refreshToken();
    // }
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${appToken.accessToken}`,
    };

    if (noCache) {
      headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
      headers['Pragma'] = 'no-cache';
      headers['Expires'] = '0';
    }

    const options: RequestInit = {
      method,
      headers,
      ...(noCache ? { cache: 'no-store' as RequestCache } : {}),
    };

    if (body) {
      options.body = JSON.stringify(body);
    }
    if (cursor !== undefined) {
      url += (url.includes('?') ? '&' : '?') + `cursor=${cursor}`;
    }

    if (limit !== undefined) {
      url += (url.includes('?') ? '&' : '?') + `limit=${limit}`;
    }

    if (noCache) {
      url += (url.includes('?') ? '&' : '?') + `_cb=${Date.now()}`;
    }

    return await fetchWrapper(url, options);
  }
}
